import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import TemplatesList from "@/components/schema-builder/TemplatesList";
import SchemaBuilder from "@/components/schema-builder/SchemaBuilder";
import { SchemaTemplate } from "@/types/schemaBuilder";

const SchemaTemplatesPage: React.FC = () => {
  const [mode, setMode] = useState<"list" | "create" | "edit">("list");
  const [currentTemplate, setCurrentTemplate] = useState<
    SchemaTemplate | undefined
  >(undefined);

  const handleCreateTemplate = () => {
    setCurrentTemplate(undefined);
    setMode("create");
  };

  const handleEditTemplate = (template: SchemaTemplate) => {
    setCurrentTemplate(template);
    setMode("edit");
  };

  const handleBackToList = () => {
    setMode("list");
    setCurrentTemplate(undefined);
  };

  const handleSaveTemplate = () => {
    // After saving, go back to the list view
    setMode("list");
  };

  return (
    <div className="w-full py-6 h-full flex flex-col">
      {mode === "list" ? (
        <TemplatesList
          onCreateTemplate={handleCreateTemplate}
          onEditTemplate={handleEditTemplate}
        />
      ) : (
        <div className="flex flex-col h-full">
          <div className="mb-4">
            <Button variant="outline" onClick={handleBackToList}>
              Back to Templates
            </Button>
          </div>
          <div className="flex-1">
            <SchemaBuilder
              initialTemplate={currentTemplate}
              onSave={handleSaveTemplate}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default SchemaTemplatesPage;
